import React from 'react';
import PropTypes from 'prop-types';
import FullModal from '../../../shared/fullModal';
import useUser from '../../../hooks/useUser';

const ChatModal = ({ hide }) => {
  const token = localStorage.getItem('tkn');
  const {
    plan: { number },
  } = useUser();
  const baseUrl = process.env.CHATBOT_URL;
  const urlChatIframe = `${baseUrl}/livechat/livechat-wom-web/#/chat/${number}/${token}`;
  return (
    <FullModal hide={hide} title="Chat de ayuda">
      <div id="divlivechat">
        <iframe
          src={urlChatIframe}
          title="Chat de ayuda"
          sandbox="allow-same-origin allow-top-navigation allow-scripts allow-forms allow-popups allow-downloads"
        />
      </div>
    </FullModal>
  );
};

ChatModal.propTypes = {
  hide: PropTypes.func.isRequired,
};

export default ChatModal;
